<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4QxJqD/tc-custom/9781429907859.jpg?1735616729430" alt="This image is the cover for the book Standing Next to History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Standing Next to History
      </h1>
      <p class="bookDescription body article font2">
        <b>A former Secret Service agent revisits his twenty-three-year career, including his time as Ronald Reagan’s bodyguard, in this “engaging” memoir (<i>Publishers Weekly</i>).</b><br/><br/>Joseph Petro served for twenty-three years as a special agent in the United States Secret Service, eleven of them at the White House and four of those as the man on the shoulder of Ronald Reagan.<br/><br/>From his days as an investigator in the field, to his time as the man on whom the life of the president depended, Petro’s journey through history is a singular look inside the most discreet law enforcement agency in the world; an unparalleled insight into Ronald and Nancy Reagan; plus an up-close-and-personal view of the late Pope John Paul II, whom Petro protected during his historic and extraordinary ten-day tour of the United States in 1987.<br/><br/>The cast of characters in these never-before-told stories ranges from the Reagans and the Pope, to Frank Sinatra, Bob Hope, Mikhail Gorbachev, Fidel Castro, Margaret Thatcher, François Mitterrand, the Shah of Iran, George H. W. Bush, Dan and Marilyn Quayle, Henry Kissinger, Nelson Rockefeller, Gerald Ford, and would-be assassins.<br/><br/><b>“A close-in view of how ‘the Great Communicator’ charmed critics and won loyal followers.” —<i>The Christian Science Monitor</i></b><br/><br/><b>“A fascinating portrait of Secret Service life.” —<i>Library Journal</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Petro, Jeffrey Robinson
      </h2>
      
      <p class="authorDescription body article"><P>After his time in the Secret Service, <B>Joseph Petro</B> went on to become head of global security and investigations for Citigroup. He lives in New York and Pennsylvania. <br><br>A college roommate of Joe Petro's, <B>Jeffrey Robinson</B> is the author of many books, including the bestselling <I>The Laundrymen</I>. An expert on international crime, he has been a keynote speaker on the subject for the United Nations, Interpol, U. S. Customs, the FBI, and many other organizations. He appeared on Fox News, Bloomberg News, and MSNBC. He lives in London.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a114c808